module.exports = __webpack_public_path__ + "img/welcome-bg3.1a187965.png";